import React from 'react'

const SectionLabel = ({ block }) => {
  if (!block) {
    return null
  }

  return (
    <p className={`section-label ${block.attrs.isCentered ? 'ta-c' : ''}`}>
      {block.attrs.label}
    </p>
  )
}

export default SectionLabel
